import React, { useRef } from "react";
import { clsx } from "../../functions.ts";
import './input-base.css';

export enum InputValidity{
  None,
  Valid,
  Invalid,
}

export default function BaseInput (props: {
	value: string,
  placeholder?:string,
  prefix?: string,
  postfix?: string,
  step?: number,
  id:string,
  valid:InputValidity,
  type: "text" | "number",
  hint?: string,
  onBlur?: () => void,
  onChange: (value: string) => void,
  onKeyDown?: (e: React.KeyboardEvent) => void,
  onClick?: (e: React.MouseEvent)=> void,
  onMouseUp?: (e: React.MouseEvent) => void,
  onMouseDown?: (e: React.MouseEvent) => void,
}){
  const element = useRef(null);

  const placeholder = props.placeholder ? props.placeholder : "";
  const charwidth = 0.6;
  const prefix_length = props.prefix ? props.prefix.length * charwidth: 0;
  const value_length = prefix_length + (props.prefix ? 0.5 : 0) + (props.value == "" && placeholder ? placeholder.length : props.value.length) * charwidth + 1;

  return <div className={clsx("base_input", props.valid == InputValidity.Invalid && "base_input--invalid")}>
        <span className={clsx("input__prefix", props.value && props.prefix && "input__prefix--visible")}>{props.prefix}</span>
        <span className={clsx("input__postfix", props.value && props.postfix && "input__postfix--visible" )} style={{left:value_length+"rem"}}>{props.postfix}</span>
        <input 
          tabIndex={0}
          aria-invalid={!props.valid}
          ref={element}
          className={"input__input"} 
          placeholder={placeholder}
          style={{paddingLeft: props.prefix ? 1+prefix_length+"rem" : "0.5rem"}} 
          id={props.id} 
          type={props.type} 
          step={props.step} 
          value={props.value} 
          onFocus={()=>{
            //element.current.select();
          }}
          onChange={(e: React.KeyboardEvent)=>{props.onChange(e.target.value);}}
          onClick={(e: React.MouseEvent)=>{
            props.onClick && props.onClick(e);
          }}
          onMouseUp={(e: React.MouseEvent)=>{
            props.onMouseUp && props.onMouseUp(e);
          }}
          onMouseDown={(e: React.MouseEvent)=>{
            props.onMouseDown && props.onMouseDown(e);
          }}
          onBlur={(e) => {
            if(props.onBlur == undefined){return};
            props.onBlur!();
          }}
          onKeyDown={(e)=>{
            props.onKeyDown && props.onKeyDown(e);
          }}
        />
        {props.hint && <div className="input__hint">{props.hint}</div>}
    </div>
}